import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {GlobalConstants} from "../data/GlobalConstants";

const modalCRUDSubject = new Subject();
const defaultId = 'defaultModalCRUD';

export const modalCRUDService = {
    onModalCRUD,
    modalCRUD,
    clear,
    showModal,
    defaultId
};


function onModalCRUD(id = defaultId) {
    return modalCRUDSubject.asObservable().pipe(filter(x => x && x.id === id));
}

function showModal({type, props, title, isAddMode = false, isEditable= true, dense = true, id = defaultId, size='lg', icon='fas fa-eye'}) {
    modalCRUD({ type, title, isAddMode, isEditable, dense, id, size, icon, props });
}

function modalCRUD(modalCRUD) {
    modalCRUD.id = modalCRUD.id || defaultId;
    modalCRUDSubject.next(modalCRUD);
}

function clear(id = defaultId) {
    modalCRUDSubject.next({ id });
}
